function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.52 7.053a.814.814 0 00-.244 1.12c.947 1.472.96 3.379.032 4.864a.809.809 0 001.37.857 6.176 6.176 0 00-.045-6.598.801.801 0 00-1.114-.244zm3.942-1.479a.807.807 0 00-1.363.864 7.855 7.855 0 01-.09 8.52.812.812 0 00.672 1.254.817.817 0 00.679-.365 9.494 9.494 0 00.102-10.273zM10.044 3.225L5.346 6.854H2.082A1.084 1.084 0 001 7.936v5.389c0 .595.48 1.075 1.075 1.075H5.34l4.698 3.629c.71.55 1.735.045 1.735-.851V4.076c.006-.89-1.018-1.395-1.728-.851z",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 1l18 18",
  stroke: "#fff",
  strokeWidth: "2",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 2l18 18",
  stroke: "#1B1836",
  strokeWidth: "2",
  strokeLinecap: "round"
})));